import * as types from "./mutation_types";
import { Feed } from "../../../../interfaces/feed";

export default {
  [types.FEED_CREATE_SET_ERROR](state: any, error: any) {
    Object.assign(state, { error });
  },

  [types.FEED_CREATE_TOGGLE_LOADING](state: any) {
    Object.assign(state, { error: "", isLoading: !state.isLoading });
  },

  [types.FEED_CREATE_SET_CREATED](state: any, created:Feed) {
    Object.assign(state, { created });
  },

  [types.FEED_CREATE_SET_VIOLATIONS](state: any, violations: any) {
    Object.assign(state, { violations });
  },

  [types.FEED_CREATE_RESET](state: any) {
    Object.assign(state, {
      created: null,
      error: "",
      isLoading: false,
      violations: null,
    });
  },
};
